import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import RequestAccessModal from './RequestAccessModal';
import styles from './Navigation.module.css';

const Navigation = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isRequestAccessModalOpen, setIsRequestAccessModalOpen] = useState(false);
  
  const handleLogout = () => {
    logout();
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleRequestAccess = () => {
    setIsRequestAccessModalOpen(true);
    setIsMobileMenuOpen(false); // Close mobile menu if open
  };

  const closeRequestAccessModal = () => {
    setIsRequestAccessModalOpen(false);
  };
  
  return (
    <nav className={styles.navigation}>
      <div className={styles.navContainer}>
        <Link to={isAuthenticated ? "/dashboard" : "/"} className={styles.navLogo}>
          <img src="/podee.png" alt="Podee" className={styles.logoImage} />
        </Link>
        
        <div className={styles.desktopNav}>
          {isAuthenticated ? (
            <>
              <div className={styles.navLinks}>
                <Link to="/dashboard" className={styles.navLink}>
                  Dashboard
                </Link>
                <Link to="/podcasts" className={styles.navLink}>
                  Podcasts
                </Link>
                <Link to="/friends" className={styles.navLink}>
                  Friends
                </Link>
              </div>
              
              <div className={styles.navUser}>
                <button onClick={handleLogout} className={`btn ${styles.logoutButton}`}>
                  Logout
                </button>
              </div>
            </>
          ) : (
            <div className={styles.navUser}>
              <button 
                className="btn btn-secondary"
                onClick={handleRequestAccess}
              >
                Request Access
              </button>
              <Link to="/signin" className="btn btn-primary">
                Sign In
              </Link>
            </div>
          )}
        </div>

        <button 
          className={styles.mobileMenuButton}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={styles.hamburger}></span>
          <span className={styles.hamburger}></span>
          <span className={styles.hamburger}></span>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className={`${styles.mobileMenu} ${styles.mobileMenuOpen}`}>
          <div className={styles.mobileMenuContent}>
            <div className={styles.mobileMenuHeader}>
              <img src="/podee.png" alt="Podee" className={styles.logoImage} style={{height: '40px'}} />
            </div>
            
            {isAuthenticated ? (
              <>
                <div className={styles.mobileNavLinks}>
                  <Link to="/dashboard" className={styles.mobileNavLink} onClick={() => setIsMobileMenuOpen(false)}>
                    Dashboard
                  </Link>
                  <Link to="/podcasts" className={styles.mobileNavLink} onClick={() => setIsMobileMenuOpen(false)}>
                    Podcasts
                  </Link>
                  <Link to="/friends" className={styles.mobileNavLink} onClick={() => setIsMobileMenuOpen(false)}>
                    Friends
                  </Link>
                  <button onClick={handleLogout} className={`btn ${styles.logoutButton} ${styles.mobileNavLink}`}>
                    Logout
                  </button>
                </div>
              </>
            ) : (
              <div className={styles.mobileAuthButtons}>
                <button 
                  className="btn btn-secondary"
                  onClick={handleRequestAccess}
                >
                  Request Access
                </button>
                <Link to="/signin" className="btn btn-primary" onClick={() => setIsMobileMenuOpen(false)}>
                  Sign In
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
      
      <RequestAccessModal 
        isOpen={isRequestAccessModalOpen}
        onClose={closeRequestAccessModal}
      />
    </nav>
  );
};

export default Navigation;
